var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popper',{class:_vm.popperClass,attrs:{"options":_vm.options,"trigger":_vm.trigger}},[_c('div',{staticClass:"popper",class:_vm.arrowPlacement},[_vm._t("popperContent")],2),_vm._t("triggerContent",null,{"slot":"reference"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }